/** Longest one-line text the app stores. The input components and the database use the same number. */
export const LINE_MAX_LENGTH = 500;

/** Longest multi-line text the app stores (notes, clinical history, proposals). */
export const MULTILINE_MAX_LENGTH = 20000;

/** Maximum lengths for user-entered text, by kind. */
export const TEXT_LIMITS = {
  /** First name, last name, city, company or place names. */
  name: LINE_MAX_LENGTH,
  /** Short label or title. */
  label: LINE_MAX_LENGTH,
  /** Phone number as typed. */
  phone: LINE_MAX_LENGTH,
  /** National id, license number, tax id. */
  identifier: LINE_MAX_LENGTH,
  /** Address line. */
  address: LINE_MAX_LENGTH,
  /** Free note or comment on a record. */
  note: MULTILINE_MAX_LENGTH,
  /** Long text such as a clinical history or a proposal. */
  longNote: MULTILINE_MAX_LENGTH,
  /** E-mail address (RFC 5321). */
  email: 254,
} as const;

export type TextLimitKind = keyof typeof TEXT_LIMITS;
